export default function (cls) {
  // 获取会员的已开通的资源列表
  cls.prototype.resourceMyList = async function () {
    const response = await cls.request({
      url: '/resource/member/index'
    })

    return response
  }

  // 我的资源详情
  cls.prototype.resourceMyDetail = async function (id, mode) {
    const response = await cls.request({
      url: '/resource/member/detail/${id}/${mode}',
      params: {
        id,
        mode
      }
    })

    return response.results
  }

  /**
   * 个人主页-资源申请
   *
   * @param mode {Integer} 资源类型，mode：优秀个人: 100，优秀公司: 200，优秀供应商: 300，优秀品牌: 400
   * @param logo {String}个人头像
   * @param name {String} 姓名
   * @param gender {String}性别
   * @param subtitle {String} 介绍自己
   * @param introduction {String} 个人简介
   * @param email {String} 邮箱
   * @param mobile {String} 联系电话
   * @param sys_area_id {Integer} 地区ID
   * @param address {String} 详细地址
   * @param resource_category_id {Integer} 资源类型
   * @param lng {Float} 位置经度
   * @param lat {Float} 位置纬度
   * @param mobile_code  国际区号
   * @returns {Promise<*>}
   */
  cls.prototype.insertPersonHomeResource = async function (mode, { logo, name, gender, subtitle, introduction, resource_category_id, email, mobile, sys_area_id, address, lng, lat, design_price = '', mobile_code }) {
    const response = await cls.request({
      method: 'post',
      url: '/resource/apply/${mode}',
      params: {
        mode
      },
      data: {
        logo,
        name,
        gender,
        subtitle,
        introduction,
        resource_category_id,
        email,
        mobile,
        sys_area_id,
        address,
        lng,
        lat,
        design_price,
        mobile_code
      }
    })

    return response
  }

  // 新增资源(公司，供应商，品牌)
  cls.prototype.resourceApplyCommon = async function (mode, { logo, name, subtitle, introduction, resource_category_id, email, mobile, sys_area_id, address, lng, lat, contact_name, license, design_price = '', mobile_code }) {
    const response = await cls.request({
      method: 'post',
      url: '/resource/apply/${mode}',
      params: {
        mode
      },
      data: {
        logo,
        name,
        subtitle,
        introduction,
        resource_category_id,
        email,
        mobile,
        sys_area_id,
        address,
        lng,
        lat,
        contact_name,
        license,
        design_price,
        mobile_code
      }
    })

    return response
  }
}



// WEBPACK FOOTER //
// ./src/modules/member/api/resourceApi.js